import { Divider, Flex, Text } from '@shared/components';
import { useMemo } from 'react';

interface ItemSetQuestionCount {
  questionInItemSet: number;
  itemSetCount: number;
}

export interface QuestionCreationCountSummaryProps {
  singleQuestionCount: number;
  itemSetQuestion: ItemSetQuestionCount[];
}

export default function QuestionCreationCountSummary(
  props: Readonly<QuestionCreationCountSummaryProps>,
) {
  const { singleQuestionCount, itemSetQuestion } = props;

  const totalQuestionCount = useMemo(
    () =>
      singleQuestionCount +
      itemSetQuestion.reduce((total, { questionInItemSet, itemSetCount }) => {
        return total + questionInItemSet * itemSetCount;
      }, 0),
    [singleQuestionCount, itemSetQuestion],
  );

  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        gap: theme.spacing(2),
        px: theme.spacing(4),
        py: theme.spacing(3),
        borderRadius: theme.shape.rounded(2),
        border: `1px solid ${theme.palette.grey[300]}`,
        backgroundColor: theme.palette.grey[50],
      })}
    >
      {singleQuestionCount ? (
        <Flex sx={(theme) => ({ gap: theme.spacing(6) })}>
          <Text sx={{ flexBasis: '110px' }}>Single</Text>
          <Text variant='body1Semibold'>{singleQuestionCount} ข้อ</Text>
        </Flex>
      ) : null}

      {itemSetQuestion.length
        ? itemSetQuestion.map(({ questionInItemSet, itemSetCount }, index) =>
            itemSetCount ? (
              <Flex key={index} sx={(theme) => ({ gap: theme.spacing(6) })}>
                <Text sx={{ flexBasis: '110px' }}>Item Set: {questionInItemSet}Q</Text>
                <Text variant='body1Semibold'>
                  {itemSetCount} Set{itemSetCount > 1 ? 's' : ''} (
                  {questionInItemSet * itemSetCount} ข้อ)
                </Text>
              </Flex>
            ) : null,
          )
        : null}

      <Divider />
      <Flex sx={(theme) => ({ gap: theme.spacing(6) })}>
        <Text sx={{ width: '110px' }}>Total Questions</Text>
        <Text variant='body1Semibold'>{totalQuestionCount} ข้อ</Text>
      </Flex>
    </Flex>
  );
}
